<template>
  <div class="modal-detailpo">
    <div class="mdp-wrapper">
      <div class="mdp-event-title">PERIODE EVENT</div>
      <div class="mdp-radio" v-for="(item, index) in filters" :key="index">
        <label class="mr20" :for="item.value">
          <input class="mr5" type="radio" :value="item.value" name="PERIODE PO" v-model="choosePeriodeEvent">
          {{ item.name}}
        </label>
      </div>
    </div>
    <div class="custom-total-event">
      <div class="text-danger text-bold">Kostum</div>
      <div class="input-wrap">
        <input type="date" v-model="eventStartDate">   
      </div>
      <div>s/d</div>
      <div class="input-wrap">
        <input type="date" v-model="eventEndDate">   
      </div>
      <div @click="runCustomDate()"><strong class="search-icons"><i class="fas fa-search"></i></strong></div>
    </div>
    <div v-show="totalEventChart">
      <ChartTotalEvent :chartData="chartData" :options="options" :height="275"/>
    </div>
    <div class="totalevent-list-wrapper" v-if="totalEventDetail">
      <div class="totalevent-list text-bold">
        <div class="totalevent-list__no">No</div>
        <div 
          class="totalevent-list__date totalevent-list__date-hover"
          @click="sortDate()"
        >
          Tgl Event <i class="fas fa-sort-numeric-down-alt" v-show="$store.state.level1.totalEventOrder == 'desc'"></i><i class="fas fa-sort-numeric-up" v-show="$store.state.level1.totalEventOrder == 'asc'"></i>
        </div>
        <div class="totalevent-list__title">Judul</div>
        <div class="totalevent-list__count text-left">Jumlah Event</div>
        <div class="totalevent-list__count text-left">Partisipasi Event</div>
        <div 
          class="totalevent-list__count text-left"
        >
          Memenangkan Event
        </div>
      </div>
      <div class="totalevent-list" v-for="(list, index) in totalEventDetail" :key="index">
        <div class="totalevent-list__no">{{ index + 1 }}</div>
        <div class="totalevent-list__date">{{ formatDate(list.EVENT_CREATE_DATE) }}</div>
        <div class="totalevent-list__title all-column">{{ list.EVENT_TITLE }}</div>
        <div class="totalevent-list__count text-left">{{ list.EVENT_COUNT }}</div>
        <div class="totalevent-list__count text-left">{{ list.EVENT_PARTICIPATED }}</div>
        <div class="totalevent-list__count text-left">{{ list.EVENT_AWARDED }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import numeral from 'numeral'
export default {
  components : {
    ChartTotalEvent: () => import('@/components/chart/ChartTotalEvent')
  },
  data() {
    return {
      sortMode: false,
      filters: [
        {
          name: '6 Bulan',
          value: '6',
        },
        {
          name: '12 Bulan',
          value: '12',
        },
        {
          name: '24 Bulan',
          value: '24',
        },
      ],
      currentPage : 1,
      totalPerPage: 20,
      chartData: null,
      options: {
        responsive: true,
        maintainAspectRatio:false,
        animation: false,
        title: {
            display: true,
            text: 'Total Event'
        },
        legend: {
          display: true,
          position: 'bottom'
        },
        tooltips: {
          mode: 'index',
          axis: 'y',
        },
        scales: {
          xAxes: [],
          yAxes: [
            {
              type: 'linear',
              ticks: {
                beginAtZero: true,
              },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    totalEventChart(){
      this.seriesData(this.$store.state.level1.totalEventChart)
      return this.$store.state.level1.totalEventChart
    },
    totalEventDetail() {
      return this.$store.state.level1.totalEventDetail
    },
    choosePeriodeEvent: {
      get: function() {
        return this.$store.state.searchStore.choosePeriodeEvent
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'eventStartDate', value: this.monthFromNow(newValue) })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'eventEndDate', value: this.$now() })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'choosePeriodeEvent', value: newValue })

        let query = {
          eventStart: `${this.monthFromNow(newValue)}`,
          eventEnd: `${this.$now()}`,
        }

        await this.$store.commit('level1/CUSTOM_TOTAL_EVENT', query)
      }
    },
    eventStartDate: {
      get: function() {
        return this.$store.state.searchStore.eventStartDate
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'eventStartDate', value: newValue})
      }
    },
    eventEndDate: {
      get: function() {
        return this.$store.state.searchStore.eventEndDate
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', { name: 'eventEndDate', value: newValue})
      }
    },
  },
  methods: {
    sortDate() {
      this.$store.commit('level1/ORDER_TOTAL_EVENT')
    },
    async runCustomDate() {
      const query = {
          eventStart: `${this.eventStartDate}`,
          eventEnd: `${this.eventEndDate}`,
      }

      await this.$store.commit('level1/CUSTOM_TOTAL_EVENT', query)
    },
    getTotalEventDetail(){
      const self = this
      if(self.items){
        const event = self.items
        if(event.length > 0){
          return event
        } 
      }
    },
    monthClassification(){
      const totalEvent = this.getTotalEventDetail()
      const dateFormat = { month : "short", year : "numeric"}

      let data = {}
      for(let i in totalEvent){
        const event = new Date(totalEvent[i].EVENT_CREATE_DATE).toLocaleString('en-GB', dateFormat)
        if(data[`${event}`] == undefined){
          data[`${event}`] = {
            'event_count' : totalEvent[i]['event_count'],
            'event_participated' : totalEvent[i]['event_participated'],
            'event_awarded' : totalEvent[i]['event_awarded']
          }
        } else {
          data[`${event}`] = {
            'event_count' : totalEvent[i]['event_count'] + data[`${event}`]['event_count'],
            'event_participated' : totalEvent[i]['event_participated'] + data[`${event}`]['event_participated'],
            'event_awarded' : totalEvent[i]['event_awarded'] + data[`${event}`]['event_awarded']
          }
        }
      }
      return data
    },
    seriesData(items) {
      const self = this
      let categories = []
      let eCount = []
      let eAwarded = []
      let eParticipated = []
      items && items.forEach(list => {
        categories.push(`${this.monthConverter(list.month)} '${this.twoDigitYear(list.year)}`)
        eCount.push(list.total_event)
        eAwarded.push(list.total_awarded)
        eParticipated.push(list.total_participated)
      })

      this.chartData = {
          labels: categories,
          datasets: [
            {
              label: 'Jumlah Event',
              backgroundColor: '#990000',
              borderColor: '#990000',
              data: eCount,
              fill: false,
              lineTension: 0
            },
            {
              label: 'Partisipasi Event',
              backgroundColor: '#ff9900',
              borderColor: '#ff9900',
              data: eParticipated,
              fill: false,
              lineTension: 0
            },
            {
              label: 'Memenangkan Event',
              backgroundColor: '#ff9966',
              borderColor: '#ff9966',
              data: eAwarded,
              fill: false,
              lineTension: 0
            },
          ]
        }
    },
  }
}
</script>
<style lang="scss">
  @import "~/assets/scss/components/poReleased.scss";
</style>